import { defineStore } from 'pinia'

export const useErrorsStore = defineStore('errors', {
    state: () => ({
        errors: [],
		confirms: [],
    }),
    actions: {
        push(error) {
            this.errors.push({
				id: this.errors.length,
				...error
			})
        },
        pop() {
            this.errors.pop()
        },
		removeError(error){
			this.errors = this.errors.filter(e => e.id != error.id)
		},
		confirm(confirm){
			// {title, message, type, btnText, onConfirm}
			this.confirms.push(confirm)
		},
		popConfirm(){
			this.confirms.pop()
		}
    }
})
